import { getFirebaseModule } from '@onhandtech/onhand-fe-shared/lib/firebase'

export default getFirebaseModule()
